export default {"src":"/_next/static/media/HTS-Finder-Icon.f1c5a8a1.svg","height":25,"width":36};